import React, { useState }from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FeedIcon from '@mui/icons-material/Feed';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { useSelector, useDispatch } from 'react-redux';
import { setFilters, resetFilters } from 'reducers/filtersPurchaseDeliverySlice';
import { resetPagination } from 'reducers/paginationPurchaseDeliverySlice';
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom'; 
import { ToastContainer } from 'react-toastify'; 
import { TodayIs} from 'components/utils/TodayIs'; 
import ImportScript from 'components/utils/ImportScript';
import Footer from "pages/main/Footer";
import Alerts from 'pages/alerts/Alerts';
import Person from 'pages/main/Person';
import Messages from 'pages/messages/Messages';  
import ColorSettings  from "pages/settings/ColorSettings";
import TypesOfPrices from"pages/settings/TypesOfPricesSettings";
import TypesOfUnits from"pages/settings/TypesOfUnitsSettings"; 
import TypesOfSizes from"pages/settings/TypesOfSizesSettings"; 
import DepartmentSettings from "pages/commonsarticle/departmentSettings/DepartmentSettings";
import RoadSettings from "pages/settings/RoadSettings";
import DocumentTypeSettings from "pages/settings/DocumentTypeSettings"; 
import CountrySettings from "pages/settings/CountrySettings"; 
import CommunitySettings from "pages/settings/CommunitySettings"
import TypesOfTaxes from "pages/settings/TypesOfTaxesSettings";
import PurchaseDeliveryFilter from "pages/purchases/purchaseDeliveryFilterList/PurchaseDeiveryFilter";

const HomePurchaseDelivery = (typeList) => {
    const {t,i18n} = useTranslation(['listDataPurchases']);
    const dispatch = useDispatch();
    const filtersPurchaseDelivery = useSelector((state) => state.filtersPurchaseDelivery); // Obtener filtros desde Redux
    const state = useSelector((state) => state);
    const enabled = state.loginUser.enabled;
    const roles = state.loginUser.roles;
    const defaultStore = state.loginUser.defaultStore;
    const [showModalGeneralSettings, setShowModalGeneralSettings] = useState(false);
    const [indexShowSettings,setIndexShowSettings]=useState(0);
    const [showModalColorSettings, setShowModalColorSettings] = useState(false);
    const [showModalTypesOfPrices, setShowModalTypesOfPrices] = useState(false);
    const [showModalTypesOfUnit,setShowModalTypesOfUnit] = useState(false);
    const [showModalTypesOfSizes,setShowModalTypesOfSizes] = useState(false);
    const [showDepartmentSettings, setShowModalDepartmentSettings] = useState(false);        
    const [showCommunitySettings, setShowCommunitySettings] = useState(false);
    const [showDocumentTypeSettings, setShowModalDocumentTypeSettings] = useState(false);
    const [showRoadSettings, setShowModalRoadSettings] = useState(false);
    const [showModalTypesOfTaxes, setShowModalTypesOfTaxes] = useState(false); 
    const [showCountrySettings, setShowModalCountrySettings] = useState(false);
    const [showModalEmployeeSettings, setShowModalEmployeeSettings] = useState(false); 
    const [showModalDriverSettings, setShowModalDriverSettings] = useState(true);
    const [showModalStoreSettings, setShowModalStoreSettings] = useState(false); 
    const [showModalFormSettings, setShowModalFormSettings] = useState(false); 
    const [showModalContractSettings, setShowModalContractSettings] = useState(false);
    const [showModalNTSettings, setShowModalNTSettings] = useState(false);   
    const [showModalShippingsSettings, setShowModalShippingsSettings] = useState(false); 
    const [showModalPurchasesDeliverySettings, setShowModalPurchasesDeliverySettings] = useState(true); 
    const [showModalArticlesSettings, setShowModalArticlesSettings] = useState(false); 
    const [showPrincipalMenu, setShowPrincipalMenu] = useState(true); 
    const [typeOfList] = useState(typeList);
    const scriptUrl = '/js/sb-admin-2.min.js'; 

    const changeSelectedLanguage = () => {
        if (i18n.language === "es") {
          i18n.changeLanguage("en");
          dispatch(setFilters({ paymentFromES: "", paymentToES: "" }));
        } else {
            i18n.changeLanguage("es");
            dispatch(setFilters({ paymentFromEN: "", paymentToEN: "" }));
        }
    };

    const closeModalPurchaseDelivery = () => {    
        setShowModalGeneralSettings(showModalGeneralSettings);
        setIndexShowSettings(0);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(showModalColorSettings);
        setShowModalTypesOfPrices(showModalTypesOfPrices);
        setShowModalTypesOfUnit(showModalTypesOfUnit);
        setShowModalTypesOfSizes(showModalTypesOfSizes); 
        setShowModalDepartmentSettings(showDepartmentSettings);
        setShowCommunitySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowModalRoadSettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(showModalEmployeeSettings);
        setShowModalDriverSettings(showModalDriverSettings);
        setShowModalStoreSettings(showModalStoreSettings); 
        setShowModalFormSettings(showModalFormSettings);
        setShowModalContractSettings(showModalContractSettings);
        setShowModalNTSettings(showModalNTSettings);
        setShowModalShippingsSettings(showModalShippingsSettings);
        setShowModalPurchasesDeliverySettings(showModalPurchasesDeliverySettings);
        setShowModalArticlesSettings(showModalArticlesSettings);
        setShowPrincipalMenu(showPrincipalMenu);
        dispatch(resetPagination());
        dispatch(resetFilters());
        return () => {};
    };

     function openModaColorsSettings(){
        setShowModalGeneralSettings(showModalGeneralSettings);
        setIndexShowSettings(1);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(true);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalTypesOfSizes(false); 
        setShowModalDepartmentSettings(false);  
        setShowCommunitySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowModalRoadSettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false); 
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false);
        setShowModalShippingsSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalArticlesSettings(false);
        setShowPrincipalMenu(false);
    }

    function openModaTypesOfPriceSettings(){
        setShowModalGeneralSettings(showModalGeneralSettings);
        setIndexShowSettings(25);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(true);
        setShowModalTypesOfUnit(false);
        setShowModalTypesOfSizes(false); 
        setShowModalDepartmentSettings(false);  
        setShowCommunitySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowModalRoadSettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false); 
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false);
        setShowModalShippingsSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalArticlesSettings(false);
        setShowPrincipalMenu(false);
    }
 
   function openModaSalesUnitsSettings(){
        setShowModalGeneralSettings(showModalGeneralSettings);
        setIndexShowSettings(24);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(true);
        setShowModalTypesOfSizes(false); 
        setShowModalDepartmentSettings(false);  
        setShowCommunitySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowModalRoadSettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false); 
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false);
        setShowModalShippingsSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalArticlesSettings(false);
        setShowPrincipalMenu(false);
    }

    function openModaTypesOfSizeSettings(){
       setShowModalGeneralSettings(showModalGeneralSettings);
        setIndexShowSettings(26);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalTypesOfSizes(true); 
        setShowModalDepartmentSettings(false);  
        setShowCommunitySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowModalRoadSettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false); 
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false);
        setShowModalShippingsSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalArticlesSettings(false);
        setShowPrincipalMenu(false);
    }

    function openModaDepartmentSettings(){
       setShowModalGeneralSettings(showModalGeneralSettings);
        setIndexShowSettings(0);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalTypesOfSizes(false); 
        setShowModalDepartmentSettings(true);  
        setShowCommunitySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowModalRoadSettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false); 
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false);
        setShowModalShippingsSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalArticlesSettings(false);
        setShowPrincipalMenu(false);
    }
   
 
    function openModaDocuemntsSettings(){
        setShowModalGeneralSettings(showModalGeneralSettings);
        setIndexShowSettings(2);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalTypesOfSizes(false); 
        setShowModalDepartmentSettings(false);  
        setShowCommunitySettings(false);
        setShowModalDocumentTypeSettings(true);
        setShowModalRoadSettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false); 
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false);
        setShowModalShippingsSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalArticlesSettings(false);
        setShowPrincipalMenu(false);
    }
    
    function openModaCountrySettings(){
        setShowModalGeneralSettings(showModalGeneralSettings);
        setIndexShowSettings(4);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalTypesOfSizes(false); 
        setShowModalDepartmentSettings(false);  
        setShowCommunitySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowModalRoadSettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalCountrySettings(true);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false); 
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false);
        setShowModalShippingsSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalArticlesSettings(false);
        setShowPrincipalMenu(false);
    }

    function openModaRoadSettings(){
        setShowModalGeneralSettings(showModalGeneralSettings);
        setIndexShowSettings(5);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalTypesOfSizes(false); 
        setShowModalDepartmentSettings(false);  
        setShowCommunitySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowModalRoadSettings(true);
        setShowModalTypesOfTaxes(false);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false); 
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false);
        setShowModalShippingsSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalArticlesSettings(false);
        setShowPrincipalMenu(false);
    }

    function openModaTypesOfTaxSettings(){
        setShowModalGeneralSettings(showModalGeneralSettings);
        setIndexShowSettings(23);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalTypesOfSizes(false); 
        setShowModalDepartmentSettings(false);  
        setShowCommunitySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowModalRoadSettings(false);
        setShowModalTypesOfTaxes(true);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false); 
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false);
        setShowModalShippingsSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalArticlesSettings(false);
        setShowPrincipalMenu(false);
    }

    function openModaCommunitySettings(){
        setShowModalGeneralSettings(showModalGeneralSettings);
        setIndexShowSettings(6);
         setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalTypesOfSizes(false); 
        setShowModalDepartmentSettings(false);  
        setShowCommunitySettings(true);
        setShowModalDocumentTypeSettings(false);
        setShowModalRoadSettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalStoreSettings(false); 
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false);
        setShowModalShippingsSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalArticlesSettings(false);
        setShowPrincipalMenu(false);
    }
     
    return (
    <>
        <ImportScript resourceUrl={scriptUrl} />
        <ToastContainer/>
        {enabled===false ? <Navigate to="/"></Navigate>:
        <div id="page-top">
           
            {/* Page Wrapper */}
            <div id="wrapper">

                {/* Sidebar */}
                <ul className="navbar-nav bg-gradient-primary sidebar toggled sidebar-dark accordion" id="accordionSidebar">

                    {/* Sidebar - Brand */}
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
                        <div className="sidebar-brand-icon rotate-n-15">
                            <DashboardIcon/>
                        </div>
                        <div className="sidebar-brand-text mx-3">{t('Text_Title')}</div>
                    </Link>

                    {/* Divider */}
                    <hr className="sidebar-divider my-0"/>

                    {/* Nav Item - Dashboard */}
                    <li className="nav-item active">
                        <div className="nav-link">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>{t('Menu_Main')}</span></div>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Sidebar - INFORMATION FILTROS APLICADOS */}
                    <li className="nav-item active">
                        <Link className="nav-link" to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"}>
                            <FeedIcon/>
                            <span> {t('Text_Information')}</span>
                        </Link>
                    </li>
                    <div className={filtersPurchaseDelivery.idFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_From')}
                    </div>
                    <li className={filtersPurchaseDelivery.idFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersPurchaseDelivery.idFrom==='' ? t('Text_Filter_Not_Apply'): filtersPurchaseDelivery.idFrom}
                    </li>
                    <div className={filtersPurchaseDelivery.idTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_To')}
                    </div>
                    <li className={filtersPurchaseDelivery.idTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersPurchaseDelivery.idTo==='' ? t('Text_Filter_Not_Apply'): filtersPurchaseDelivery.idTo}
                    </li>
                    <div className={filtersPurchaseDelivery.datepurchaseFrom===null || filtersPurchaseDelivery.datepurchaseFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_DatePurchase_From')}
                    </div>
                    <li className={filtersPurchaseDelivery.datepurchaseFrom === null || filtersPurchaseDelivery.datepurchaseFrom === '' ? "sidebar-heading text-warning" : "sidebar-heading text-white"}>
                        {filtersPurchaseDelivery.datepurchaseFrom === null || filtersPurchaseDelivery.datepurchaseFrom === ''
                        ? t('Text_Filter_Not_Apply')
                        : new Date(filtersPurchaseDelivery.datepurchaseFrom).toLocaleDateString(i18n.language === "es" ? 'es-ES' : 'en-US')}
                    </li>
                    <div className={filtersPurchaseDelivery.datepurchaseTo===null || filtersPurchaseDelivery.datepurchaseTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_DatePurchase_To')}
                    </div>
                    <li className={filtersPurchaseDelivery.datepurchaseTo === null || filtersPurchaseDelivery.datepurchaseTo === '' ? "sidebar-heading text-warning" : "sidebar-heading text-white"}>
                        {filtersPurchaseDelivery.datepurchaseTo === null || filtersPurchaseDelivery.datepurchaseTo === ''
                            ? t('Text_Filter_Not_Apply')
                            : new Date(filtersPurchaseDelivery.datepurchaseTo).toLocaleDateString(i18n.language === "es" ? 'es-ES' : 'en-US')}
                    </li>

                    <div className={filtersPurchaseDelivery.opt_tras_store_idFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_Provider_From')}
                    </div>
                    <li className={filtersPurchaseDelivery.opt_tras_store_idFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersPurchaseDelivery.opt_tras_store_idFrom==='' ? t('Text_Filter_Not_Apply'): filtersPurchaseDelivery.opt_tras_store_idFrom}
                    </li>
                    <div className={filtersPurchaseDelivery.opt_tras_store_idTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_Provider_To')}
                    </div>
                    <li className={filtersPurchaseDelivery.opt_tras_store_idTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersPurchaseDelivery.opt_tras_store_idTo==='' ? t('Text_Filter_Not_Apply'): filtersPurchaseDelivery.opt_tras_store_idTo}
                    </li>

                     <div className={filtersPurchaseDelivery.opt_tras_licenseplateFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_LicensePlate_From')}
                    </div>
                    <li className={filtersPurchaseDelivery.opt_tras_licenseplateFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersPurchaseDelivery.opt_tras_licenseplateFrom==='' ? t('Text_Filter_Not_Apply'): filtersPurchaseDelivery.opt_tras_licenseplateFrom}
                    </li>
                    <div className={filtersPurchaseDelivery.opt_tras_licenseplateTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_LicensePlate_To')}
                    </div>
                    <li className={filtersPurchaseDelivery.opt_tras_licenseplateTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersPurchaseDelivery.opt_tras_licenseplateTo==='' ? t('Text_Filter_Not_Apply'): filtersPurchaseDelivery.opt_tras_licenseplateTo}
                    </li>


                    <div className={filtersPurchaseDelivery.marcaFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_marcaFrom')}
                    </div>
                    <li className={filtersPurchaseDelivery.marcaFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersPurchaseDelivery.marcaFrom==='' ? t('Text_Filter_Not_Apply'): filtersPurchaseDelivery.marcaFrom}
                    </li>
                    <div className={filtersPurchaseDelivery.marcaTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_marcaTo')}
                    </div>
                    <li className={filtersPurchaseDelivery.marcaTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersPurchaseDelivery.marcaTo==='' ? t('Text_Filter_Not_Apply'): filtersPurchaseDelivery.marcaTo}
                    </li>

                    <div className={filtersPurchaseDelivery.modeloFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_modeloFrom')}
                    </div>
                    <li className={filtersPurchaseDelivery.modeloFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersPurchaseDelivery.modeloFrom==='' ? t('Text_Filter_Not_Apply'): filtersPurchaseDelivery.modeloFrom}
                    </li>
                    <div className={filtersPurchaseDelivery.modeloTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_mmodeloTo')}
                    </div>
                    <li className={filtersPurchaseDelivery.modeloTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersPurchaseDelivery.modeloTo==='' ? t('Text_Filter_Not_Apply'): filtersPurchaseDelivery.modeloTo}
                    </li>

                    <div className={(filtersPurchaseDelivery.paymentFromEN==='' && filtersPurchaseDelivery.paymentFromES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_payment_From')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersPurchaseDelivery.paymentFromEN==='' ? t('Text_Filter_Not_Apply'): filtersPurchaseDelivery.paymentFromEN:filtersPurchaseDelivery.paymentFromES==='' ? t('Text_Filter_Not_Apply'): filtersPurchaseDelivery.paymentFromES}
                    </li>
                    <div className={(filtersPurchaseDelivery.paymentToEN==='' && filtersPurchaseDelivery.paymentToES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_payment_To')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersPurchaseDelivery.paymentToEN==='' ? t('Text_Filter_Not_Apply'): filtersPurchaseDelivery.paymentToEN:filtersPurchaseDelivery.paymentToES==='' ? t('Text_Filter_Not_Apply'): filtersPurchaseDelivery.paymentToES}
                    </li>               

                    
                    <li className="sidebar-heading text-warning">
                    &nbsp;
                    </li>
                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Heading */}
                    {/* Nav Item - Admin Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Settings"))&&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"} data-toggle="collapse" data-target="#collapseAdmin"
                                aria-expanded="true" aria-controls="collapseAdmin">
                                <SettingsIcon/>
                                <span>{t('Menu_Settings')}</span>
                            </Link>
                            <div id="collapseAdmin" className="collapse" aria-labelledby="headingAdmin"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Menu_Settings')}</h6>
                                    
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Colors"))?
                                    <Link className="collapse-item"  to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"} onClick={openModaColorsSettings}>{t('SubMenu_Settings_Type_Colors')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"}>{t('SubMenu_Settings_Type_Colors')} </Link>}              
                                                                      
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Docuemnts"))&&
                                    <Link className="collapse-item" to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"} onClick={openModaDocuemntsSettings}>{t('SubMenu_Settings_Type_Documents')} </Link>}
                                    
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Locations"))&&
                                    <Link className="collapse-item" to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"} onClick={openModaCountrySettings}>{t('SubMenu_Settings_Type_Locations')} </Link>}
                                   
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Roads"))&&
                                    <Link className="collapse-item" to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"} onClick={openModaRoadSettings}>{t('SubMenu_Settings_Type_Roads')} </Link>}
                                 
                                   {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Community"))&&
                                    <Link className="collapse-item" to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"} onClick={openModaCommunitySettings}>{t('SubMenu_Settings_Type_Community')} </Link>}
                                  
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_TypeOfPrice"))?
                                    <Link className="collapse-item" to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"} onClick={openModaTypesOfPriceSettings}>{t('SubMenu_Settings_Type_Prices')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"}>{t('SubMenu_Settings_Type_Prices')} </Link>}              
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_TypeOfUnit"))?
                                    <Link className="collapse-item"  to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"} onClick={openModaSalesUnitsSettings}>{t('SubMenu_Settings_SalesUnits')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"}>{t('SubMenu_Settings_SalesUnits')} </Link>}
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_TypeOfSize"))?
                                    <Link className="collapse-item" to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"} onClick={openModaTypesOfSizeSettings}>{t('SubMenu_Settings_TypesOfSizes')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"}>{t('SubMenu_Settings_TypesOfSizes')} </Link>}
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_TypeOfTax"))?
                                    <Link className="collapse-item"  to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"} onClick={openModaTypesOfTaxSettings}>{t('SubMenu_Settings_TypesOfTaxes')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"}>{t('SubMenu_Settings_TypesOfTaxes')} </Link>}
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Department"))?
                                    <Link className="collapse-item" to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"} onClick={openModaDepartmentSettings}>{t('SubMenu_Settings_Departments')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"}>{t('SubMenu_Settings_Departments')} </Link>}
                                                                                                          
                                    <Link className="collapse-item" to={typeOfList.typeList==="1"?"/purchasedeliveryin":"/purchasedeliveryout"} onClick={changeSelectedLanguage}>{i18n.language==="es"?t('SubMenu_Settings_ChangeToEnglish'):t('SubMenu_Settings_ChangeToSpanish')}</Link>
                                   
                                </div>
                            </div>
                        </li>
                    }
                    {/* Nav Item - Charts */}                  
                    <li className="nav-item">
                        <Link className="nav-link" to="/home" onClick={closeModalPurchaseDelivery} >
                            <LogoutIcon/>
                            <span>{t('Button_Back')}</span>
                        </Link>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider d-none d-md-block"/>

                    {/* Sidebar Toggler (Sidebar) */}
                    <div className="text-center d-none d-md-inline">
                        <button className="rounded-circle border-0" id="sidebarToggle"></button>
                    </div>

          
                </ul>
                {/* End of Sidebar */}

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">

                {/* Main Content */}
                <div id="content">

                    {/* Topbar  */}
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                        {/* Sidebar Toggle (Topbar)  */}
                        <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                            <i className="fa fa-bars"></i>
                        </button>
                        
                        {/* Topbar Navbar */}
                        <ul className="navbar-nav ml-auto">
                            <Person/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                               <div className="driver-name-ok">
                                    <br/>
                                    {t('Text_StoreSelected')}&nbsp;{ defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                                </div>   
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - Alerts */}
                            <Alerts/>
                            {/* Nav Item - Messages */}
                            <Messages/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - User Information */}
                            <li className="nav-item dropdown no-arrow mx-1">
                                <br/>
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                    <TodayIs/>  
                                </span>
                            </li>
                        </ul>
                    </nav>
                    {/* End of Topbar */}

                {/* Show Modals */}  
                <PurchaseDeliveryFilter
                    showModalPurchasesDeliverySettings={showModalPurchasesDeliverySettings}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    typeOfList={typeOfList.typeList}
                />
                <ColorSettings  
                    showModalColorSettings={showModalColorSettings}
                    setShowModalColorSettings={setShowModalColorSettings}
                    setIndexShowSettings={setIndexShowSettings}
                    setShowModalGeneralSettings={setShowModalGeneralSettings}
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={false}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={true}
                />
                <TypesOfPrices                  
                    showModalTypesOfPrices={showModalTypesOfPrices}
                    setShowModalTypesOfPrices={setShowModalTypesOfPrices}
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings}
                    setShowModalArticlesSettings={setShowModalArticlesSettings} 
                    isArticle={false}
                     setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={true}
                />
                <TypesOfUnits   
                    showModalTypesOfUnit={showModalTypesOfUnit}
                    setShowModalTypesOfUnit={setShowModalTypesOfUnit}
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={false} 
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={true}
            
                />
                <TypesOfSizes  
                    showModalTypesOfSizes={showModalTypesOfSizes} 
                    setShowModalTypesOfSizes={setShowModalTypesOfSizes}
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={false} 
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={true}
                />  
                <DepartmentSettings  
                    setShowPrincipalMenu={setShowPrincipalMenu}
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    showDepartmentSettings={showDepartmentSettings} 
                    setShowModalDepartmentSettings={setShowModalDepartmentSettings}
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={true}
                /> 
                <CommunitySettings  
                    showCommunitySettings={showCommunitySettings} 
                    setShowCommunitySettings={setShowCommunitySettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={false}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false}
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalShippingsSettings={setShowModalShippingsSettings}
                    isShipping={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={true}
                />
                <DocumentTypeSettings  
                    showDocumentTypeSettings={showDocumentTypeSettings}
                    setShowModalDocumentTypeSettings={setShowModalDocumentTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={false}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false}
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalShippingsSettings={setShowModalShippingsSettings}
                    isShipping={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={true}
                />
               
                <RoadSettings  
                    showRoadSettings={showRoadSettings} 
                    setShowModalRoadSettings={setShowModalRoadSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={false}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false}
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalShippingsSettings={setShowModalShippingsSettings}
                    isShipping={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={true}
                />
                 <TypesOfTaxes  
                    showModalTypesOfTaxes={showModalTypesOfTaxes}
                    setShowModalTypesOfTaxes={setShowModalTypesOfTaxes}
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings} 
                    isArticle={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={true}
                /> 
                <CountrySettings  
                    showCountrySettings={showCountrySettings} 
                    setShowModalCountrySettings={setShowModalCountrySettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={false}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalShippingsSettings={setShowModalShippingsSettings}
                    isShipping={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={true}
                />
                 
                </div>
                {/* End of Main Content */}

                {/* Footer */}
                <Footer/>
                {/* End of Footer */}

            </div>
            {/* End of Content Wrapper */}

          </div>
          {/* End of Page Wrapper */}
         
      </div>}
      {/* End of Body */}

    </>
  )
};

export default HomePurchaseDelivery;
